import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "draft-product--item-left draft-product--item__loading"
}
const _hoisted_2 = { class: "draft-product--item__check transparent" }
const _hoisted_3 = { class: "draft-product--item__quantity__inner" }
const _hoisted_4 = {
  key: 0,
  class: "draft-product--item__check success t-icon has-tooltip",
  "data-tooltip": "Product is valid"
}
const _hoisted_5 = {
  key: 1,
  class: "draft-product--item__check warn t-icon has-tooltip",
  "data-tooltip": "'The product quantity is invalid'"
}
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = { class: "medium draft-product--item__quantity-value" }
const _hoisted_9 = { class: "draft-product--item-right" }
const _hoisted_10 = { class: "draft-product--item__title" }
const _hoisted_11 = { class: "draft-product--item__title-inner" }
const _hoisted_12 = { class: "bold highlight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createBlock($setup["SelectableList"], {
    class: "draft-products-list",
    items: $props.items,
    store: $props.store
  }, {
    item: _withCtx(({ item: product, index }) => [
      _createVNode($setup["SelectableItem"], {
        class: _normalizeClass(["draft-product--item", { active: $props.activeIndex === index, 'has-tooltip': product.status === 'final', readonly: $props.readonly }]),
        payload: product,
        "data-tooltip": product.status === 'final' ? 'Order product has been fulfilled' : undefined,
        onClick: ($event: any) => ($props.readonly || product.status === 'final' ? undefined : _ctx.$emit('search', index))
      }, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_spinner, {
                    scale: .3,
                    visible: true
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["draft-product--item-left", { editable: product.sys?.id && product.sys?.type }])
              }, [
                _createVNode($setup["QuantityControl"], {
                  class: "draft-product--item__quantity",
                  modelValue: product.quantity,
                  "onUpdate:modelValue": ($event: any) => ((product.quantity) = $event),
                  controls: "icons",
                  "control-size": 5,
                  min: 1,
                  disabled: !(product.sys?.id && product.sys?.type)
                }, {
                  value: _withCtx(({ value }) => [
                    _createElementVNode("div", _hoisted_3, [
                      (($setup.dict[$setup.toSku(product.sku)] || $setup.dict[product.ean]) && parseInt(product.quantity) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "e"))
                        : (($setup.dict[$setup.toSku(product.sku)] || $setup.dict[product.ean]) && parseInt(product.quantity) <= 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "l"))
                          : (product.sku || (Array.isArray(product.ean) ? product.ean?.join(', ') : product.ean))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "draft-product--item__check warn t-icon has-tooltip",
                                "data-tooltip": `Product has sku/ean but was not found in the database. ${parseInt(product.quantity) <= 0 ? 'Additionally the product quantity is invalid' : ''}`
                              }, "l", 8, _hoisted_6))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "draft-product--item__check error t-icon has-tooltip",
                                "data-tooltip": `Product is missing sufficient identifiable information (sku/ean). ${parseInt(product.quantity) <= 0 ? 'Additionally the product quantity is invalid' : ''}`
                              }, "j", 8, _hoisted_7)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(value) + "x", 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
              ], 2)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(product.sku || '') + " " + _toDisplayString(product.sku && product.ean ? '|' : '') + " " + _toDisplayString(product.ean || ''), 1),
                _createElementVNode("h5", _hoisted_12, _toDisplayString(product.title || 'No title set'), 1)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["payload", "class", "data-tooltip", "onClick"])
    ]),
    _: 1
  }, 8, ["items", "store"]))
}